import React, { ChangeEvent } from 'react'
import dayjs from 'dayjs'
import { useAppSelector } from 'reduxTyped'
import { DatePicker, l } from '@manychat/manyui'

import WeekDaySelect from 'common/core/components/WeekDaySelect/WeekDaySelect'
import { getBotTimezone } from 'common/core/selectors/appSelectors'
import { BetweenDatesConditionTime, BetweenDatesConditionValue } from 'common/filter/interfaces'
import { WEEKDAYS } from 'constants/constants'

import cm from './TimeBetween.module.css'

interface TimeBetweenProps {
  value: BetweenDatesConditionValue
  onCurrentTimeFromChange: (
    event: ChangeEvent<{ value: BetweenDatesConditionTime['time'] }>,
  ) => void
  onCurrentTimeToChange: (event: ChangeEvent<{ value: BetweenDatesConditionTime['time'] }>) => void
  onCurrentTimeWeekdaysChange: (event: ChangeEvent<{ value: typeof WEEKDAYS }>) => void
}

export const TimeBetween: React.FC<TimeBetweenProps> = ({
  value,
  onCurrentTimeFromChange,
  onCurrentTimeToChange,
  onCurrentTimeWeekdaysChange,
}) => {
  const botTimezone = useAppSelector(getBotTimezone)
  const { from, to, weekdays, time_zone: timeZone } = value
  const botTZ = botTimezone ? dayjs().tz(botTimezone).format('Z') : null
  const utc = timeZone ? `${timeZone}:00` : botTZ

  return (
    <div className={cm.root}>
      <div className="d-flex">
        <div>
          {l.translate('From:')}
          <DatePicker value={from.time} onChange={onCurrentTimeFromChange} type="time" />
        </div>
        <div className="m-l">
          {l.translate('To:')}
          <DatePicker value={to.time} onChange={onCurrentTimeToChange} type="time" />
        </div>
      </div>
      <div className="m-t">
        {l.translate('Days:')}
        <WeekDaySelect
          name="weekdays"
          value={weekdays}
          onChange={onCurrentTimeWeekdaysChange}
          oneOrMore
        />
      </div>
      <div className="m-t text-secondary">
        {l.translate('The time is shown in UTC {utc}', { utc })}
      </div>
    </div>
  )
}
